import React from 'react';
import { useOutletContext } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { USER_ROLES } from '../../../util/constants/AppConstants';
import { formatNumberWithCommas, formatWinInfo } from '../../../util/HelperFunctions';

import UsersIcon from '../../../assets/images/icons/users.svg';
import UsersActiveIcon from '../../../assets/images/icons/users-active.svg';
import CalenderIcon from '../../../assets/images/icons/calender.svg';
import MessageIcon from '../../../assets/images/icons/message.svg';
import AwardIcon from '../../../assets/images/icons/award.svg';
import './PollCard.scss';

dayjs.extend(utc);

const PollCard = ({ poll, handlePollClick }) => {
  const { userInfo } = useOutletContext();

  const councillorRoleValue = USER_ROLES.find((role) => role.short === 'Councillor').value;
  const isCouncillor = userInfo && userInfo.role === councillorRoleValue;

  return (
    <div key={poll.id} className="poll-card" onClick={() => handlePollClick(poll.id)}>
      <div className="poll-card__title">{poll.label}</div>
      {!isCouncillor && (
        <div className="poll-card__percent">
          {formatWinInfo(poll.win_percentage, poll.winner_party_name, poll.second_party_name)}
        </div>
      )}
      <div className="poll-card__value">
        <img src={UsersIcon} alt="Population" /> {formatNumberWithCommas(poll.population)} resident
        {poll.population === 1 ? '' : 's'}
      </div>
      <div className="poll-card__value">
        <img src={UsersActiveIcon} alt="Constituents" /> {formatNumberWithCommas(poll.constituents_count)} active
        constituent{poll.constituents_count === 1 ? '' : 's'}
      </div>
      <div className="poll-card__value">
        <img src={CalenderIcon} alt="Calender" />
        Last Email: {poll.last_message_date ? dayjs(poll.last_message_date).format('M/D/YYYY') : '-'}
      </div>
      <div className="poll-card__value">
        <img src={MessageIcon} alt="Email" />
        {poll.message_count} email{poll.message_count === 1 ? '' : 's'}
      </div>
      <div className="poll-card__value">
        <img src={AwardIcon} alt="Top category" />
        <p>Top category:</p>
      </div>
      <div className="poll-card__value">{poll.top_category ?? '-'}</div>
    </div>
  );
};

export default PollCard;
